<div class="ui pagination menu" *ngIf="pagesTotal > 0">
  <a class="icon item" [class.disabled]="numberPage === 1" (click)="first()">
    <i class="angle double left icon"></i>
  </a>
  <a class="icon item" [class.disabled]="numberPage === 1" (click)="previus()">
    <i class="angle left icon"></i>
  </a>
   
  <ng-container *ngFor="let page of pagesTotals">
    <a class="item" [ngClass]="{'pagina-actual': page === numberPage}" (click)="cambiarPagina(page)">
      {{ page }}
    </a>
  </ng-container>

  <a class="disabled item" *ngIf="pagesTotals[pagesTotals.length - 1] < pagesTotal">
    ...
  </a>

  <a class="icon item" [class.disabled]="numberPage === pagesTotal" (click)="next()">
    <i class="angle right icon"></i>
  </a>
  <a class="icon item" [class.disabled]="numberPage === pagesTotal" (click)="last()">
    <i class="angle double right icon"></i>
  </a>
</div>